// extracted by mini-css-extract-plugin
module.exports = {"modalbody":"CustomModal_modalbody__D6Kvp","close-btn":"CustomModal_close-btn__Llz3l"};